"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseAttributesKey = exports.supportedIdKey = exports.supportedTimestampKey = void 0;
exports.supportedTimestampKey = 'timestamp';
exports.supportedIdKey = 'id';
exports.baseAttributesKey = 'baseAttributes';
